import * as signalR from "@microsoft/signalr";
import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { NotificationModel } from "../models/notification-model";
import { ConfigurationService } from "./configuration.service";
import { HttpTransportType } from "@microsoft/signalr";

@Injectable({
  providedIn: "root",
})
export class NotificationService {
  private notificationSubject = new Subject<NotificationModel>();
  private hubConnection: signalR.HubConnection | undefined;
  private started: boolean = false;

  public get notification$() {
    return this.notificationSubject.asObservable();
  }

  constructor(private configurations: ConfigurationService) {}

  public async init() {
    const branchId = JSON.parse(localStorage.getItem("BranchId"));
    let url = "/hubs/notification";
    if (this.started) return;
    url += `?BranchId=${branchId}`;
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(
      `${this.configurations.baseUrl}${url}`,HttpTransportType.WebSockets)
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build();
    this.hubConnection.on("Send", (notification) => {
      this.started = true;
      this.notificationSubject.next(notification);
    });
    this.start();
    this.hubConnection.onclose((e) => {
      this.started === false;
      console.log('Error : notif : ' + e.message);
    });
  }

  public async stop() {
    if (this.started) {
      this.hubConnection
        .stop()
        .then((x) => {
          this.started = false;
          this.start();
        })
        .catch((x) => {
          this.started = false;
        });
    }
  }

  private async start() {
    if (this.started === true) return;
   await this.hubConnection
      .start()
      .then(async() => {
        this.started = true;
      })
      .catch(async(err) => {
        this.started = false;
        await this.init();
      });
  }
}
